import { useDispatch, useSelector } from "react-redux";
import { useEffect, useRef } from "react";
import { useCookies } from "react-cookie";
import { useLocation, useNavigationType } from "react-router-dom";

import { sendULFEvent } from "state/config-slice";
import { AppDispatch } from "state/reducers-combiner";
import { cartState } from "state/cart-slice";
import { ULFEvents } from "types/ULF";
import { offersState } from "state/offers-slice";

const useTracking = () => {
  const dispatch: AppDispatch = useDispatch();
  const [cookies] = useCookies();
  const navigationType = useNavigationType();
  const location = useLocation();
  const prevLocationValue = useRef({ ...location });
  const { cart } = useSelector(cartState);
  const { offersList } = useSelector(offersState);
  const partnersInCart = cart.map((offer) => offer.partner);
  const offerNamesInCart = cart.map((offer) => offer.name);
  const offerNames = offersList.map((offer) => offer.name);
  const partnerNames = offersList.map((offer) => offer.partner);

  useEffect(() => {
    if (prevLocationValue.current.pathname !== location.pathname) {
      if (navigationType === "POP") {
        dispatch(
          sendULFEvent({
            "event-name": ULFEvents.GO_BACK,
            page: window.location.pathname,
            source: cookies.SOURCE,
            isTrackingAllowed: cookies.SUBSCRIPTIONPLUS_TRACKING || false,
          }),
        );
      }

      if (!location.pathname.includes("/offer")) {
        if (location.pathname.includes("/basket") || location.pathname.includes("/checkout")) {
          dispatch(
            sendULFEvent({
              "event-name": ULFEvents.PAGE_VIEW,
              page: window.location.pathname,
              "offer-name": offerNamesInCart?.toString(),
              partner: partnersInCart ? [...new Set(partnersInCart)].toString() : "",
              source: cookies.SOURCE,
              isTrackingAllowed: cookies.SUBSCRIPTIONPLUS_TRACKING || false,
            }),
          );
        } else {
          dispatch(
            sendULFEvent({
              "event-name": ULFEvents.PAGE_VIEW,
              page: window.location.pathname,
              source: cookies.SOURCE,
              partner: [...new Set(partnerNames)].toString(),
              "offer-name": offerNames.toString(),
              isTrackingAllowed: cookies.SUBSCRIPTIONPLUS_TRACKING || false,
            }),
          );
        }
      }

      prevLocationValue.current = location;
    }
  }, [
    location,
    dispatch,
    cookies.SUBSCRIPTIONPLUS_TRACKING,
    navigationType,
    prevLocationValue,
    partnersInCart,
    offerNamesInCart,
    cookies.SOURCE,
    partnerNames,
    offerNames,
  ]);
};

export default useTracking;
